module.exports = __webpack_public_path__ + "img/school3.08d5bfdd.jpg";